/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuItemsDto as DigiworkMaitreDPosDtoMenuItemsMenuItemsDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuItems/menu-items-dto';

export interface GetAllMenuItems$Params {
  venueId?: string;
  isMenuItemRemoved?: boolean;
  isMenuCategoryRemoved?: boolean;
  searchTerm?: string;
}

export function getAllMenuItems(http: HttpClient, rootUrl: string, params?: GetAllMenuItems$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto>> {
  const rb = new RequestBuilder(rootUrl, getAllMenuItems.PATH, 'get');
  if (params) {
    rb.query('venueId', params.venueId, {});
    rb.query('isMenuItemRemoved', params.isMenuItemRemoved, {});
    rb.query('isMenuCategoryRemoved', params.isMenuCategoryRemoved, {});
    rb.query('searchTerm', params.searchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto>;
    })
  );
}

getAllMenuItems.PATH = '/api/menu-categories/menu-items';
